import { render, staticRenderFns } from "./ShippingLocal.vue?vue&type=template&id=73979701&scoped=true"
import script from "./ShippingLocal.vue?vue&type=script&lang=js"
export * from "./ShippingLocal.vue?vue&type=script&lang=js"
import style0 from "./ShippingLocal.vue?vue&type=style&index=0&id=73979701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73979701",
  null
  
)

export default component.exports